export const TRIPLE_EIGHT_COMPANY_NAME = '888';